import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { InvoicingComponent } from './invoicing.component';
import { InvoicingResolve } from './invoicing.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'invoicing',
        component: InvoicingComponent,
        resolve: {
          portal: InvoicingResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class InvoicingRoutingModule {}
